import React from "react";
import "../../css/WhyContainer.css";
import dudanick from "../../img/DN.jpg";

import { Button } from "@material-ui/core";

function TermsContainer() {
  return (
    <div className="why__container">
      <div>
        <h1>Terms</h1>
      </div>
      <div className="whyContainer__letter">
        {" "}
        <p>
          Last updated: November 11th 2020. <br />
          <br />
          These terms and conditions set out the terms and conditions on which
          we offer to supply to you the content available on this Website. By
          using or accessing our Website, you agree to be legally bound by these
          terms and conditions. If you have any comments, problems or questions
          regarding our Website, please get in touch with us at
          team@dragapp.com. <br />
          <br />
          Use of our Website The content of the pages of this website is for
          your general information and use only. It is subject to change without
          notice. Neither we nor any third parties provide any warranty or
          guarantee as to the accuracy, timeliness, performance, completeness or
          suitability of the information and materials found on this website for
          any particular purpose. <br />
          <br />
          Liability for content <br />
          The content of this site has been created with the greatest of care.
          We cannot, however, guarantee that the information in it is accurate,
          complete or up-to-date. You acknowledge that such information and
          materials may contain inaccuracies or errors and we expressly exclude
          liability for any such inaccuracies or errors to the fullest extent
          permitted by law. <br />
          <br />
          What if I see something on the Website that infringes my copyright?{" "}
          <br />
          We respect others’ intellectual property rights, and we reserve the
          right to delete or disable Content alleged to be infringing. Written
          notification of claimed copyright infringements must be submitted to
          the following Designated Agent for the Website: <br />
          <br />
          DRAGAPP.COM LIMITED <br />
          Building 18, Gateway 1000 Arlington Business Park Whittle Way,
          Stevenage SG1 2FP England, U.K. <br />
          ‍Telephone Number: +44 07895 013 283
          <br />
          ‍Email: gdpr@dragapp.com <br />
          <br />
          Please include the following in your written notice to our DMCA agent:
          <br />- A physical or electronic signature of a person authorized to
          act on behalf of the owner of the exclusive right that is allegedly
          infringed; <br />
          - Identification of the copyrighted work claimed to have been
          infringed; <br />
          - Identification of the material that is claimed to be infringing or
          to be the subject of infringing activity and that is to be removed or
          access to which is to be disabled, and information reasonably
          sufficient to permit FounderContent.com to locate the material; <br />
          - Information reasonably sufficient to permit FounderContent.com to
          contact the complaining party, such as an address, telephone number,
          and, if available, an electronic mail address at which the complaining
          party may be contacted; <br />
          - A statement that the complaining party has a good faith belief that
          use of the material in the manner complained of is not authorized by
          the copyright owner, its agent or the law.
          <br />
          <br />
          Registration and access to the Website To subscribe to the Website,
          you must be at least 18 years of age to enter into and form a legally
          binding contract. The information that you provide is covered by our
          Privacy Policy. <br />
          <br />
          As a user of our Website, you agree to represent yourself accurately
          and truthfully at all times. During the registration process, you will
          need to provide basic details, such as your email address or name. You
          may not use anyone else’s information, unless you have their
          permission and they are a member of your household. You can request an
          edit, deletion or export of your account information at any time by
          contacting us at gdpr@dragapp.com. Links to our Website and to other
          sites We may provide a link to other sites that allow you to leave the
          Website to access third-party materials (“Linked Materials”). These
          Linked Materials are made available solely for your convenience.
          FounderContent.com is not responsible for, does not monitor, has no
          control over and does not endorse the Linked Materials. You access the
          Linked Materials at your own risk. <br />
          <br />
          You are hereby granted a limited, revocable and nonexclusive right to
          create a hyperlink to any page of the Website so long as the link does
          not portray FounderContent.com, in a false, misleading, derogatory or
          otherwise offensive or damaging manner. <br />
          <br />
          Do our Services cost anything?
          <br />
          Our Services are currently free, but we reserve the right to charge
          for certain or all Services in the future. We will notify you before
          any Services you are then using begin carrying a fee, and if you wish
          to continue using such Services, you must pay all applicable fees for
          such Services.
        </p>
      </div>
    </div>
  );
}

export default TermsContainer;
